import AuthClient from './authClient';

export class AuthService {
  getArkkeoUser(credentials) {
    return AuthClient.getArkkeoUser(credentials).then(
      (response) => response.result,
    );
  }
}

export default new AuthService();
